interface AppConfig {
  API_BASE_URL?: string;
  BASE_PATH?: string;
  RECAPTCHA_SITE_KEY?: string;
  API_TIMEOUT?: number | string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const hasValue = (value: unknown): boolean =>
  value !== undefined && value !== null && String(value).trim() !== "";

export const getRuntimeConfig = <T = string>(
  key: keyof AppConfig,
  envKey?: string,
  defaultValue?: T
): T => {
  if (typeof window !== "undefined" && window.__APP_CONFIG__) {
    const runtimeValue = window.__APP_CONFIG__[key];
    if (hasValue(runtimeValue)) {
      return runtimeValue as T;
    }
  }

  if (envKey && hasValue(process.env[envKey])) {
    return process.env[envKey] as T;
  }

  if (defaultValue !== undefined) {
    return defaultValue;
  }

  throw new Error(`Missing required configuration: ${String(key)}`);
};

